/*
 * @Author: Ryan
 * @Date: 2026-01-26
 * @Description: CTA section - Ready to Create AI Images
 */
import React from 'react';

import StartButton from './StartButton';

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        {/* Title */}
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Create Images in Seconds
        </h2>

        {/* Description */}
        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Stop wasting hours on editing or searching for the right image. Produce fresh,
          polished visuals in moments with FalcoCut and stay ahead of your deadlines.
        </p>

        {/* CTA Button */}
        <StartButton text="Create Your Image Now" />
      </div>
    </section>
  );
};

export default CTASection;
